import _ from 'lodash';
import { useHistory } from 'react-router';
import { getRoutePath } from '../util/routeUtils';

interface IndexByAny {
  [key: string]: any,
};

const storage:IndexByAny = {
};

function difference(object:any, base:any) {
	function changes(object:any, base:any) {
		return _.transform(object, function(result:any, value:any, key:any) {
			if (!_.isEqual(value, base[key])) {
				result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
			}
		});
	}
	return changes(object, base);
}

//<save-sqlinfo: Called by ChangeTrackable.acceptChanges
export function setCleanStateStorage(key: string, object:any) {
  storage[key] = object;
}
export function getCleanStateStorage(key:string) {
  return storage[key];
}
export function delCleanStateStorage(key:string) {
  delete storage[key];
}
//save-sqlinfo>

export default function useDirtyCheck(nameParam: string, propertiesToIgnore:Array<string> = []) {
  const history = useHistory();

  const url = `${history.location.pathname}${history.location.search}`;

  const name = !url.includes('common/joblistview')
    ? `${nameParam}-${getRoutePath(history.location.pathname)}`
    : nameParam;

  function setCleanState(cleanState:object) {
    storage[name] = _.omit(cleanState, propertiesToIgnore);
  }

  function isDirtyComparedTo(newState:object):boolean {
    const compareObject = _.omit(newState, propertiesToIgnore);
    const dirty = !_.isEqual(storage[name], compareObject);

    if (dirty && process.env.NODE_ENV !== 'production') {
      window.console.log('Dirty check failed');
      window.console.log(difference(storage[name], compareObject));
      window.console.log(storage[name]);
      window.console.log(compareObject);
    }

    return dirty;
  }
  
  function dirtyCleanup() {
    delete storage[name];
  }

  /**
   * [save-sqlinfo] Return original entity 
   */
  function getCleanState() {
    return storage[name];
  }

  return {setCleanState, isDirtyComparedTo, dirtyCleanup, 
    //[save-sqlinfo]
    getCleanState};
}
